package com.crowpay.views.dialogs

import com.crowpay.LineItemCompletionMessage
import com.crowpay.ScopeViewInterface
import com.crowpay._id
import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.completionResponse.CompletionResponse
import com.crowpay.completionResponse.LineItemConcern
import com.crowpay.completionResponse.LineItemReview
import com.crowpay.completionResponse.concerns
import com.crowpay.completionResponse.message
import com.crowpay.completionResponse.serializable
import com.crowpay.created
import com.crowpay.lineItem
import com.crowpay.scopeSet
import com.crowpay.sdk.notNullSession
import com.crowpay.utils.AdjustedLineItem
import com.crowpay.utils.SignalingMap
import com.crowpay.utils.notNull
import com.crowpay.utils.renderDollars
import com.crowpay.views.components.Indent
import com.crowpay.views.components.indentIfWideCol
import com.crowpay.views.components.label2
import com.crowpay.views.components.nav.viewIsNarrow
import com.crowpay.views.components.nav.viewIsWide
import com.crowpay.views.components.requiredField3
import com.crowpay.views.components.requiredLabel2
import com.crowpay.views.components.tabIndentCol
import com.crowpay.views.screens.common.DialogWithDialog
import com.crowpay.views.screens.common.DialogWithDialogOrPage
import com.crowpay.views.screens.common.secondDialog
import com.crowpay.views.theming.AppColors
import com.crowpay.views.theming.ApprovalToggles
import com.crowpay.views.theming.ApprovedSemantic
import com.crowpay.views.theming.DeniedSemantic
import com.crowpay.views.theming.ForegroundSemantic
import com.crowpay.views.theming.LightSection
import com.crowpay.views.theming.LineItemStateSemantic
import com.crowpay.views.theming.Outlined
import com.crowpay.views.theming.TabSemantics
import com.crowpay.views.theming.body
import com.crowpay.views.theming.bodyBold
import com.crowpay.views.theming.notificationBar
import com.crowpay.views.theming.outlined
import com.crowpay.views.theming.primaryButton
import com.crowpay.views.theming.removeOutline
import com.crowpay.views.theming.secondaryButton
import com.crowpay.views.theming.smallBody
import com.crowpay.views.theming.specCenteredText
import com.crowpay.views.theming.title
import com.lightningkite.UUID
import com.lightningkite.kiteui.models.Align
import com.lightningkite.kiteui.models.CardSemantic
import com.lightningkite.kiteui.models.Color
import com.lightningkite.kiteui.models.Icon
import com.lightningkite.kiteui.models.minus
import com.lightningkite.kiteui.models.px
import com.lightningkite.kiteui.models.rem
import com.lightningkite.kiteui.models.times
import com.lightningkite.kiteui.navigation.dialogScreenNavigator
import com.lightningkite.kiteui.navigation.screenNavigator
import com.lightningkite.kiteui.reactive.await
import com.lightningkite.kiteui.reactive.bind
import com.lightningkite.kiteui.reactive.contains
import com.lightningkite.kiteui.reactive.equalTo
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.reactive.lens
import com.lightningkite.kiteui.reactive.shared
import com.lightningkite.kiteui.views.ViewModifiable
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.atEnd
import com.lightningkite.kiteui.views.centered
import com.lightningkite.kiteui.views.compact
import com.lightningkite.kiteui.views.dialog
import com.lightningkite.kiteui.views.direct.DismissBackground
import com.lightningkite.kiteui.views.direct.RowOrCol
import com.lightningkite.kiteui.views.direct.button
import com.lightningkite.kiteui.views.direct.col
import com.lightningkite.kiteui.views.direct.gravity
import com.lightningkite.kiteui.views.direct.icon
import com.lightningkite.kiteui.views.direct.onClick
import com.lightningkite.kiteui.views.direct.onlyWhen
import com.lightningkite.kiteui.views.direct.radioToggleButton
import com.lightningkite.kiteui.views.direct.row
import com.lightningkite.kiteui.views.direct.rowCollapsingToColumn
import com.lightningkite.kiteui.views.direct.scrolls
import com.lightningkite.kiteui.views.direct.sizeConstraints
import com.lightningkite.kiteui.views.direct.space
import com.lightningkite.kiteui.views.direct.stack
import com.lightningkite.kiteui.views.direct.textInput
import com.lightningkite.kiteui.views.direct.toggleButton
import com.lightningkite.kiteui.views.direct.weight
import com.lightningkite.kiteui.views.dynamicTheme
import com.lightningkite.kiteui.views.expanding
import com.lightningkite.kiteui.views.fieldTheme
import com.lightningkite.kiteui.views.l2.icon
import com.lightningkite.lightningdb.MassModification
import com.lightningkite.lightningdb.Query
import com.lightningkite.lightningdb.condition
import com.lightningkite.lightningdb.inside
import com.lightningkite.lightningdb.modification
import com.lightningkite.lightningdb.sort
import com.lightningkite.serialization.lensPath
import kotlinx.coroutines.launch

private fun ViewWriter.radioOptionSelectLineItems(
    items: List<AdjustedLineItem>,
    reviews: SignalingMap<UUID, LineItemReview>,
): RowOrCol {
    val minChars = 35

    return col {
        for (item in items) {
            col {
                spacing = theme.spacing * 0.5

                val review = reviews.getWritable(item._id)

                val approved = review.lens(
                    get = { it == null },
                    set = {
                        if (it) null
                        else LineItemReview(item._id, emptySet(), "")
                    }
                )

                compact - row {
                    rowCollapsingToColumn(AppDimensions.normalCollapseWidth) {
                        spacing = AppDimensions.cornerRadii * 2
                        (ApprovalToggles + ApprovedSemantic).onNext - radioToggleButton {
                            row {
                                centered - icon {
                                    source = Icon.done
                                    description = "Approve Line Item"
                                }
                                centered - body("Approve")
                                space(0.1)
                            }
                            checked bind approved
                        }
                        (ApprovalToggles + DeniedSemantic).onNext - radioToggleButton {
                            row {
                                centered - icon {
                                    description = "Line Item Not Ready"
                                    source = Icon.close
                                }
                                centered - body("Not Ready")
                                space(0.1)
                            }
                            checked bind approved.equalTo(false)
                        }
                    }

                    expanding - rowCollapsingToColumn(AppDimensions.normalCollapseWidth) {
                        if (viewIsNarrow) dynamicTheme {
                            (if (approved()) ApprovedSemantic else DeniedSemantic) + CardSemantic
                        }
                        else themeChoice += Outlined

                        weight(2.25f) - gravity(Align.Start, Align.Center) - bodyBold(item.name)
                        weight(1f) - gravity(Align.Start, Align.Center) - LineItemStateSemantic(item.state).onNext - body {
                            content = item.state.displayName
                            align = Align.Center
                        }
                        weight(0.8f) - gravity(Align.Start, Align.Center) - body {
                            content = item.price.renderDollars()
                            align = Align.Center
                        }
                    }
                }

                onlyWhen { !approved() } - indentIfWideCol(Indent.Tab) {
                    requiredLabel2("Concerns") {
                        row {
                            val concerns = review.notNull.lensPath { it.concerns }
                            toggleButton {
                                spacing = 0.25.rem
                                checked bind concerns.contains(LineItemConcern.Incomplete)
                                specCenteredText("Incomplete")
                            }
                            toggleButton {
                                spacing = 0.25.rem
                                checked bind concerns.contains(LineItemConcern.QualityConcern)
                                specCenteredText("Quality")
                            }
                            toggleButton {
                                spacing = 0.25.rem
                                checked bind concerns.contains(LineItemConcern.Other)
                                specCenteredText("Other")
                            }
                        }
                    }
                    col {
                        spacing = 0.px
                        requiredField3("Reason") {
                            expanding - textInput {
                                content bind review.notNull.lensPath { it.message }
                                hint = "Minimum $minChars characters"
                            }
                        }
                        atEnd - smallBody {
                            ::content {
                                val remaining = minChars - (review()?.message?.length ?: 0)
                                if (remaining <= 0) ""
                                else "($remaining) more characters required"
                            }
                        }
                    }
                    row {
                        visible = false
                    }
                }
            }
        }
    }
}

class ScopeSetReviewDialog(
    val items: List<AdjustedLineItem>,
    val messages: List<LineItemCompletionMessage>,
    val scope: ScopeViewInterface
) : DialogWithDialogOrPage {
    val minChars = 35
    val reviews = SignalingMap<UUID, LineItemReview>()

    val submitEnabled = shared {
        reviews().values.all { it.message.length >= minChars && it.concerns.isNotEmpty() }
    }

    private fun ViewWriter.page() = col {
        title("Review Request Sign Off: ${scope.scopeTitle}")

        col {
            notificationBar(AppColors.blue) - body(
                "Items marked 'Not Ready' will have their funds held until the issue is resolved by the contractor."
            )
            notificationBar(AppColors.yellow) - body(
                "Unchecked items will be approved and funds released, so make sure to mark every item you think is not ready. If no items are ready, consider filing a project-wide issue instead."
            )
        }

        label2("Select Approve or Not Ready for Each Work Item") {
            sizeConstraints(minHeight = 20.rem) - radioOptionSelectLineItems(items, reviews)
        }
        row {
            primaryButton - button {
                ::enabled { submitEnabled() }
                specCenteredText {
                    if (reviews().isEmpty()) "Approval All Work"
                    else "Submit"
                }
                onClick("Submit") {
                    val rejected = reviews.size
                    val approved = items.size - rejected

                    secondDialog.value = GenericConfirmationDialog(
                        "Submit Review",
                        when {
                            rejected == 0 -> "Are you sure you want to approve and release payment for all $approved items?"
                            approved == 0 -> "Are you sure you want to mark all $rejected items as not ready? You may want to consider filing a project-wide issue instead."
                            else -> "Are you sure you want ot mark $rejected items as not ready? This will release payment for the other $approved items."
                        },
                        confirmationText = "Submit",
                        dismiss = { dismissSecondDialog() }
                    ) { confirmed ->
                        if (!confirmed) return@GenericConfirmationDialog

                        val session = notNullSession()
                        val requests = session.lineItemCompletionMessages
                            .query(
                                Query(
                                    condition { it.lineItem inside items.map { it._id } },
                                    orderBy = sort { it.created.ascending() }
                                )
                            )
                            .await()
                            .mapNotNull {
                                val request = it.responseType as? CompletionResponse.RequestComplete ?: return@mapNotNull null
                                it.lineItem to request
                            }
                            .toMap()

                        items.forEach { item ->
                            val review = reviews[item._id]

                            val message = LineItemCompletionMessage(
                                project = item.project,
                                lineItem = item._id,
                                sender = session.userId,
                                clientMessage = true,
                                message = review?.message ?: "",
                                responseTypeSerializable =
                                    review
                                        ?.let { CompletionResponse.ClientResponse(reasons = it.concerns).serializable() }
                                        ?: CompletionResponse.Accept(
                                            requests[item._id] ?: return@forEach,
                                            session.currentAccess()
                                        ).serializable()
                            )

                            session.nonCached.lineItemCompletionMessage.sendMessage(message)
                        }

                        if (reviews.isNotEmpty()) {
                            val scopes = items.mapNotNull { it.scopeView }.toSet()
                            session.scopeViews.bulkModify(
                                MassModification(
                                    condition { it._id inside scopes },
                                    modification { it.scopeSet assign false }
                                )
                            )
                        }

                        screenNavigator.dismiss()
                    }
                }
            }
            secondaryButton - button {
                specCenteredText("Go Back")
                onClick("Exit") { screenNavigator.dismiss() }
            }
        }
    }

    override fun DismissBackground.renderDialog(): ViewModifiable = scrolls - stack {
        launch {
            notNullSession().lineItemCompletionMessages.markAsRead(messages)
        }

        centered - dialog - stack {
            spacing = AppDimensions.fullIndent
            sizeConstraints(width = AppDimensions.pageWidth - AppDimensions.fullIndent * 2) - removeOutline - page()
        }
    }

    override fun ViewWriter.renderAsPage(): ViewModifiable = scrolls - page()
}